import React from 'react';
import { AppBar, Box, IconButton, Toolbar } from '@mui/material';
import AccountCircleOutlined from '@mui/icons-material/AccountCircleOutlined';
import MenuRounded from '@mui/icons-material/MenuRounded';
import { useNavigate } from 'react-router-dom';

import lanFooter from '../assets/lan-footer.png';

export default function TopBar({ onOpenMenu }) {
  const navigate = useNavigate();

  return (
    <>
      <AppBar
        position="fixed"
        elevation={0}
        sx={{
          top: 0,
          left: 0,
          right: 0,
          zIndex: (theme) => theme.zIndex.appBar,
          bgcolor: '#fff7e9',
          color: 'text.primary',
        }}
      >
        <Toolbar
          variant="dense"
          sx={{
            justifyContent: 'space-between',
            alignItems: 'center',
            minHeight: { xs: 52, sm: 56 },
            px: 1,
          }}
        >
          <IconButton
            edge="start"
            aria-label="Open menu"
            size="large"
            onClick={() => onOpenMenu?.()}
            sx={{
              flexShrink: 0,
              color: 'text.primary',
              '& .MuiSvgIcon-root': { fontSize: 32 },
            }}
          >
            <MenuRounded />
          </IconButton>
          <Box
            sx={{
              flex: 1,
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              minWidth: 0,
              px: 1,
            }}
          >
            <Box
              component="img"
              src={lanFooter}
              alt="Naatu"
              sx={{
                height: { xs: 36, sm: 44 },
                maxWidth: 'min(360px, 82vw)',
                width: 'auto',
                objectFit: 'contain',
              }}
            />
          </Box>
          <IconButton
            edge="end"
            aria-label="Account"
            size="large"
            onClick={() => navigate('/v2/account')}
            sx={{
              flexShrink: 0,
              color: 'text.primary',
              '& .MuiSvgIcon-root': { fontSize: 32 },
            }}
          >
            <AccountCircleOutlined />
          </IconButton>
        </Toolbar>
      </AppBar>
      {/* Reserve space so main content starts below the fixed bar */}
      <Toolbar
        variant="dense"
        sx={{
          visibility: 'hidden',
          pointerEvents: 'none',
          minHeight: { xs: 52, sm: 56 },
        }}
        aria-hidden
      />
    </>
  );
}
